// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"759":"99dc77b1","926":"6acc89dd"}[chunkId] + ".chunk.css";
};